import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Container,
  Card,
  Table,
  Button,
  Badge,
  Spinner,
  Form,
} from "react-bootstrap";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";
import DetalleBajaModal from "../modales/DetalleBajaModal";

import {API_BASE} from "../../services/apirest";

const stageLabels = {
  SolicitudBaja: "Pendiente validación",
  CapturaBaja: "Captura de baja",
  Ejecutada: "Ejecutada",
  VistoDistribuidor: "Visto",
};



const formatDate = (fecha) => {
  if (!fecha) return "-";
  const d = new Date(fecha);
  if (isNaN(d)) return fecha;
  return d.toLocaleDateString();
};

export default function BajasEnProceso() {
  const rolId = parseInt(localStorage.getItem("rol_id"), 10);
  const token = localStorage.getItem("token");
  const [profile, setProfile] = useState(null);
  const [list, setList] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [advanceLoading, setAdvanceLoading] = useState(false);
  const bajaStageLabels = {
    SolicitudBaja: "Pendiente validación de baja",
    CapturaBaja: "Captura de baja",
    Ejecutada: "Baja ejecutada",
    VistoDistribuidor: "Visto",
  };

  // hooks siempre arriba
  const headers = useMemo(
      () => ({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      [token]
  );

  const stageForRole = useMemo(() => {
    if (rolId === 3 || rolId === 2) return "SolicitudBaja";
    if (rolId === 1 || rolId === 14) return "PROCESS";
    if (rolId === 4) return "Ejecutada";
    return null;
  }, [rolId]);

  useEffect(() => {
    if (![1, 2, 3, 4, 14].includes(rolId)) return;
    fetch(`${API_BASE}/perfil.php`, { headers })
        .then((r) => r.json())
        .then((d) => {
          if (d.status === "success") setProfile(d.result.user);
        })
        .catch(console.error);
  }, [headers, rolId]);

  const load = useCallback(async () => {
    if (![1, 2, 3, 4, 14].includes(rolId)) return;
    if ((rolId === 3 || rolId === 4) && !profile) return;

    setLoading(true);
    try {
      if (!stageForRole) {
        setList([]);
        return;
      }
      const url = `${API_BASE}/solicitudes.php?baja_stage=${encodeURIComponent(
          stageForRole
      )}`;
      const res = await fetch(url, { headers });
      const json = await res.json();
      let items = json.result?.solicitudes || [];

      if (rolId === 3 || rolId === 2) {
        const first = (...cands) => cands.find(v => v !== undefined && v !== null && v !== "");
        const norm = (v) => (v ? String(v).trim().toLowerCase() : "");
        const mySup = norm(first(profile?.correo_supervisor, profile?.Usuario, profile?.usuario, profile?.email));
        if (!mySup) {
          items = [];
        } else {
          items = items.filter(s => {
            const sup = norm(first(s.correo_supervisor, s.supervisor_correo, s.supervisor_email));
            return sup === mySup;
          });
        }
      } else if (rolId === 4) {
        items = items.filter(
            (s) => Number(s.creado_por) === Number(profile?.UsuarioId)
        );
      }

      setList(items);
    } catch (err) {
      console.error(err);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [stageForRole, headers, profile, rolId]);

  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, [load]);

  const filtered = useMemo(() => {
    if (!Array.isArray(list)) return [];
    const term = searchText.trim().toLowerCase();
    if (!term) return list;
    return list.filter((s) => {
      const fullName = `${s.nombre_usuario || ""} ${s.apellido_paterno || ""} ${s.apellido_materno || ""}`.toLowerCase();
      return (
          fullName.includes(term) ||
          (s.rfc || "").toLowerCase().includes(term) ||
          (s.usuario_red || "").toLowerCase().includes(term)
      );
    });
  }, [list, searchText]);

  // guardia de ruta después de todos los hooks
  if (![1, 2, 3, 4, 14].includes(rolId)) return <Navigate to="/" replace />;

  const humanStage = (stage) => stageLabels[stage] || stage;

const handleAdvance = async () => {
  if (!selected) return;

  let action = null;
  const payload = { SolicitudId: selected.SolicitudId };

  if ((rolId === 3 || rolId === 2) && selected.baja_stage === "SolicitudBaja") {
    action = "aprobar_baja";
  } else if ((rolId === 1 || rolId === 14) && selected.baja_stage === "CapturaBaja") {
    action = "ejecutar_baja";
  } else if (rolId === 4 && selected.baja_stage === "Ejecutada") {
    action = "confirmar_visto_baja";
    payload.Estado = "Visto";
  }

  if (!action) return;

  payload.action = action;

  try {
    setAdvanceLoading(true); // 🔁 empieza loading

    const res = await fetch(`${API_BASE}/solicitudes.php`, {
      method: "PUT",
      headers,
      body: JSON.stringify(payload),
    });
    const json = await res.json();
      if (json.status === "success" || json.status === "ok") {
        Swal.fire({
          icon: "success",
          title: "¡LISTO¡",
          text: `Se avanzó correctamente`,
          didOpen: () => {
            const c = Swal.getContainer();
            if (c) c.style.zIndex = "13000";
          },
        });
        window.dispatchEvent(new Event("solicitudes:refresh"));
        window.dispatchEvent(new Event("inbox:refresh"));
        await load();
        setShowModal(false);
      } else {
      throw new Error(json.result?.error_msg || "Fallo");
    }
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: err.message || "No se pudo avanzar el flujo",
      didOpen: () => {
        const c = Swal.getContainer();
        if (c) c.style.zIndex = "13000";
      },
    });
  } finally {
    setAdvanceLoading(false); // 🔁 termina loading
  }
};


  const isBajaActive = (s) =>
      !!s?.baja_stage && s.baja_stage !== "VistoDistribuidor";
  function getResponsable(s) {
    // BAJA primero
    if (isBajaActive(s)) {
      switch (s.baja_stage) {
        case "SolicitudBaja": return s.supervisor || "(Supervisor no asignado)";
        case "CapturaBaja":   return "Analista";
        case "Rechazada":
        case "Ejecutada":
          return (`${s.creado_por_nombre || ""} ${s.creado_por_apellido || ""}`).trim() || "(Distribuidor)";
        default: return "—";
      }
    }}
  const getEstadoDisplay = (s) => {
    if (isBajaActive(s)) {
      return bajaStageLabels[s.baja_stage] || s.baja_stage;
    }};

  const exportToExcel = () => {
    if (filtered.length === 0) return;
    const headersCsv = ["NOMBRE COMPLETO", "RFC", "FECHA", "ETAPA BAJA", "RESPONSABLE"];
    const rows = filtered.map(s => [
      `${s.nombre_usuario} ${s.apellido_paterno} ${s.apellido_materno}`.trim(),
      s.rfc,
      s.Fecha,
      getEstadoDisplay(s),
      getResponsable(s),
    ]);
    const csv = [
      headersCsv.join(","),
      ...rows.map(r => r.map(cell => `"${cell}"`).join(","))
    ].join("\r\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "solicitudes_bajas_export.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
      <div className="app-container">
        <Container className="my-5">
          <Card className="shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-0">Bajas en proceso</h5>
              </div>
              <Badge pill bg={filtered.length ? "primary" : "secondary"}>
                {filtered.length}
              </Badge>
            </Card.Header>
            <Card.Body>
              <div className="mb-3 d-flex flex-wrap gap-2 align-items-center">
                <Form.Control
                    placeholder="Buscar por nombre, RFC o usuario red..."
                    style={{ maxWidth: 360 }}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
                <div className="ms-auto">
                  <Button variant="outline-secondary" size="sm" onClick={exportToExcel}>
                    Exportar
                  </Button>
                </div>
                <div className="ms-auto">
                  <Button variant="outline-secondary" size="sm" onClick={load}>
                    Refrescar
                  </Button>
                </div>
              </div>

              {loading ? (
                  <div
                      className="d-flex justify-content-center"
                      style={{ height: 200 }}
                  >
                    <Spinner animation="border" />
                  </div>
              ) : !filtered.length ? (
                  <p className="text-center text-muted">
                    No hay solicitudes para este paso.
                  </p>
              ) : (
                  <Table responsive hover striped className="align-middle mb-0">
                    <thead className="table-light">
                    <tr>
                      <th>Nombre</th>
                      <th>RFC</th>
                      <th>Fecha</th>
                      <th>Etapa baja</th>
                      <th>Responsable</th>
                      <th className="text-center">Acción</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filtered.map((s) => (
                        <tr
                            key={s.SolicitudId}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelected(s);
                              setShowModal(true);
                            }}
                        >
                          <td>
                            {`${s.nombre_usuario || ""} ${
                                s.apellido_paterno || ""
                            } ${s.apellido_materno || ""}`.trim()}
                          </td>
                          <td>{s.rfc}</td>
                          <td>{formatDate(s.Fecha)}</td>
                          <td>{humanStage(s.baja_stage)}</td>
                          <td>{s.supervisor || "-"}</td>
                          <td
                              className="text-center"
                              onClick={(e) => e.stopPropagation()}
                          >
                            {(((rolId === 3 || rolId === 2) && s.baja_stage === "SolicitudBaja") ||
                                ((rolId === 1 || rolId === 14) && s.baja_stage === "CapturaBaja") ||
                                (rolId === 4 && s.baja_stage === "Ejecutada")) && (
                                <Button
                                    size="sm"
                                    variant={
                                      rolId === 4
                                          ? "danger"
                                          : rolId === 3
                                              ? "danger"
                                              : "danger"
                                    }
                                    onClick={() => {
                                      setSelected(s);
                                      setShowModal(true);
                                    }}
                                >
                                  {rolId === 3 || rolId === 2
                                      ? "Aprobar baja"
                                      : (rolId === 1 || rolId === 14)
                                          ? "Ejecutar baja"
                                          : "Marcar visto"}
                                </Button>
                            )}
                          </td>
                        </tr>
                    ))}
                    </tbody>
                  </Table>
              )}
            </Card.Body>
          </Card>
            <DetalleBajaModal
              open={showModal}
              onClose={() => setShowModal(false)}
              selected={selected}
              rolId={rolId}
              onAdvance={handleAdvance}
              advanceLoading={advanceLoading}   // 👈 nuevo prop
            />
        </Container>
      </div>
  );
}